import { Injectable } from '@angular/core'

import { Action } from '@ngrx/store'
import { Actions, Effect } from '@ngrx/effects'

import { Observable, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { toPayload } from '../../core/helpers/rx-pipes'

import { StockService } from '../services/stock-service'

import * as stock from '../actions/stock.actions'

@Injectable()
export class StockEffects {
    constructor(
        private actions$: Actions,
        private stockSvc: StockService
    ){ }

    @Effect()
    getStock$: Observable<Action> = 
        this.actions$.ofType<stock.Get>(stock.GET)
            .pipe(
                toPayload<string[]>(),
                switchMap(codes => {
                    return this.stockSvc.getStock(codes)
                        .pipe(
                            map(result => new stock.GetSuccess(result)),
                            catchError(e => of(new stock.GetFailed(e)))
                        )
                })
            )
}
